/**
 * home-reviews.js — lights the dot for whichever review card is in view, and
 * moves the rail when a dot is pressed.
 *
 * The rail works without this: it is a scroll-snapping row of real elements.
 * All this adds is the indicator and the tap target.
 */
(function () {
  'use strict';

  if (customElements.get('kosha-reviews')) return;

  class KoshaReviews extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-reviews-rail]');
      this.dots = this.querySelectorAll('[data-reviews-dot]');
      if (!this.rail || !this.dots.length) return;

      this.addEventListener('click', this.onClick.bind(this));
      this.rail.addEventListener('scroll', this.sync.bind(this), { passive: true });
    }

    onClick(event) {
      var dot = event.target.closest && event.target.closest('[data-reviews-dot]');
      if (!dot) return;
      var index = parseInt(dot.getAttribute('data-reviews-dot'), 10);
      var items = this.rail.querySelectorAll('[data-reviews-item]');
      if (!items[index]) return;
      this.rail.scrollTo({
        left: items[index].offsetLeft - items[0].offsetLeft,
        behavior: 'smooth',
      });
    }

    sync() {
      var items = this.rail.querySelectorAll('[data-reviews-item]');
      if (items.length < 2) return;
      /* Measured off the first two items rather than assumed, so the step stays
         right whatever the gap and column width resolve to at this width. */
      var step = items[1].offsetLeft - items[0].offsetLeft;
      var index = step > 0 ? Math.round(this.rail.scrollLeft / step) : 0;
      index = Math.max(0, Math.min(index, items.length - 1));
      Array.prototype.forEach.call(this.dots, function (dot, i) {
        dot.classList.toggle('is-on', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  customElements.define('kosha-reviews', KoshaReviews);
})();
